import { EXPERT_AVAILABILITY_UPDATED } from './userActionsActionsTypes';

export const initialState = {
  isExpertAvailable: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EXPERT_AVAILABILITY_UPDATED:
      return {
        ...state,
        isExpertAvailable: action.value,
      };
    default:
      return state;
  }
};
